import Description from './components/Description';
import Title from './components/Title';
export default {
  Title: Title,
  Description: Description
};